module.exports = __webpack_public_path__ + "static/logo_amanat-1df608cc623d106082eb8fc22c4ef6d3.svg";